<template>
  <div class="content">
      <div class="tip">{{tip}}</div>
      <div class="box">
        <div class="list" v-for="( data , key) in list" :key="key">
          <p>{{key}} {{ list }}</p>
          <span>{{delRepeatData(data)}}</span>
        </div>
      </div>
     <div class="btns">
      <el-button  @click="handleClose">取消</el-button>
      <el-button type="primary"  @click="handleClose">确定</el-button>
    </div>
  </div>
</template>

<script>
export default {
  props: ['cbs', 'tip', 'list'],
  data() {
    return {}
  },
  methods: {
    delRepeatData(list) {
      return [...new Set([...list])].join('、')
    },
    handleClose() {
       this.$emit('close')
    }
  }
}
</script>

<style lang="scss" scoped>
.box {
  max-height: 300px;
  overflow-y: auto;
}
.btns {
  margin-top: 25px;
  text-align: right;
}

.content {
  max-height: 600px;
  p {
    margin: 4px 0;
  }
  span {
    padding-left: 20px;
    display: block;
  }
}

</style>